import {BaseAppModel} from "./AppModel";

export default class FirmwareConfig extends BaseAppModel<FirmwareConfig> {
    productId = -1
    dir?: string = undefined
}
